import React, { Component } from 'react';
import { AppState } from '../../../app/store/rootReducers';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { callLastRequest } from "../../../app/store/captcha/actions";
import ReCAPTCHA from 'react-google-recaptcha';
import Config from '../../../config/config';
import  './captcha.scss';

type CaptchaProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class CaptchaComponent extends Component<CaptchaProps, {}> {

  constructor(props:any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value: any) {
    if (value) {
      this.props.callLastRequest(value);
    }
  }


  render() {
    return (
      this.props.isCaptchaRequired ?
        <div className={'webshop-captcha text-center'}>
          <div className={'webshop-captcha-content d-inline-block text-center'}>
            <ReCAPTCHA
              theme={"light"}
              size={'normal'}
              sitekey={Config.CAPTCHA_PUBLIC}
              onChange={this.handleChange}
              type={'image'}
            />
          </div>
        </div> : null
    );
  }

}

const mapStateToProps = (state: AppState) => {
  return {
    isCaptchaRequired: state.captcha.isCaptchaRequired,
    captchaEntity: state.captcha.entity,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    callLastRequest
  }, dispatch
);

export default (connect(
  mapStateToProps,
  mapDispatchToProps,
)(CaptchaComponent));
